/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React context
import { useMaterialUIController, setLayout } from "context";
import Footer from "examples/Footer";

function PublicDashboardLayout({ children }) {
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, "dashboard");
    }, [pathname]);

    return (
        <MDBox
            sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",  // Ensures full-height layout
                position: "relative",
                paddingBottom: "2.5rem",  // Give space for the footer so it doesn't overlap content
                p: 3,

                [breakpoints.up("xl")]: {
                    // marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
                    transition: transitions.create(["margin-left", "margin-right"], {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                    }),
                },
            })}
        >
            {/* Main content that takes available space */}
            <MDBox
                sx={{
                    flexGrow: 1,  // This makes the children take the available space above the footer
                }}
            >
                {children}
            </MDBox>

            {/* Footer stays at the bottom */}
            <Footer
                style={{
                    position: "fixed",
                    float: "right",
                }}
            />
        </MDBox>
    );
}

// Typechecking props for the PublicDashboardLayout
PublicDashboardLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PublicDashboardLayout;